export default function DSA_Linked_Lists_Memory() {
  return <div>DSA_Linked_Lists_Memory Component</div>;
}
